import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  styled,
  useTheme,
  alpha
} from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(4, 0),
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`,
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
}));

const TermsOfService = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          textAlign: 'center',
          mb: 4,
          background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
        Terms of Service
      </Typography>

      <StyledPaper>
        <SectionTitle variant="h5">1. Acceptance of Terms</SectionTitle>
        <Typography variant="body1" paragraph>
          By accessing and using Chaudhary's Life, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
        </Typography>

        <SectionTitle variant="h5">2. User Accounts</SectionTitle>
        <Typography variant="body1" paragraph>
          To use our services, you must:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            Be at least 18 years old
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Provide accurate and complete information
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Maintain the security of your account
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Not share your account credentials
          </Typography>
        </Box>

        <SectionTitle variant="h5">3. User Content</SectionTitle>
        <Typography variant="body1" paragraph>
          You are responsible for:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            The accuracy of the information you provide
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Obtaining necessary permissions for shared content
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Respecting the privacy of family members
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Not sharing sensitive personal information
          </Typography>
        </Box>

        <SectionTitle variant="h5">4. Prohibited Activities</SectionTitle>
        <Typography variant="body1" paragraph>
          You agree not to:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            Use the service for illegal purposes
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Harass or harm other users
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Share false or misleading information
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Violate intellectual property rights
          </Typography>
        </Box>

        <SectionTitle variant="h5">5. Service Modifications</SectionTitle>
        <Typography variant="body1" paragraph>
          We reserve the right to modify or discontinue any part of our service at any time. We will notify users of significant changes to these terms.
        </Typography>

        <SectionTitle variant="h5">6. Limitation of Liability</SectionTitle>
        <Typography variant="body1" paragraph>
          Chaudhary's Life is not liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
        </Typography>

        <SectionTitle variant="h5">7. Contact Information</SectionTitle>
        <Typography variant="body1" paragraph>
          For questions about these Terms of Service, please contact us at:
        </Typography>
        <Typography variant="body1" paragraph>
          Email: legal@chaudharylife.com
        </Typography>
        <Typography variant="body1">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </StyledPaper>
    </Container>
  );
};

export default TermsOfService; 